import { useCallback, useEffect, useState } from 'react'

const usePromoAsset = (currentPromo, assetName) => {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [asset, setAsset] = useState(null)

    useEffect(() => {
        if (!currentPromo) {
            return;
        }

        const fetchImage = async () => {
            try {
                const response = await import(`../assets/promos/${currentPromo.path}/${assetName}`)
                setAsset(response.default)
            } catch (err) {
                setError(err)
            } finally {
                setLoading(false)
            }
        }

        fetchImage()
    }, [currentPromo, assetName])

    return {
        loading,
        error,
        asset,
    }
}

export default usePromoAsset